import { render } from "./AdminContactsView.vue?vue&type=template&id=682c0842&ts=true"
import script from "./AdminContactsView.vue?vue&type=script&lang=ts"
export * from "./AdminContactsView.vue?vue&type=script&lang=ts"

import "./AdminContactsView.vue?vue&type=style&index=0&id=682c0842&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__